import { createReducer, on } from '@ngrx/store';
import * as DocumentsActions from './documents.actions';
import { initialDocumentsState } from './documents.state';

export const documentsReducer = createReducer(
  initialDocumentsState,
  on(DocumentsActions.loadDocuments, (state) => ({ ...state, loading: true })),
  on(DocumentsActions.loadDocumentsSuccess, (state, { documents }) => ({
    ...state,
    documents,
    loading: false,
    error: null,
  })),
  on(DocumentsActions.loadDocumentsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
